import { render, staticRenderFns } from "./element.vue?vue&type=template&id=40468347"
import script from "./element.vue?vue&type=script&lang=js"
export * from "./element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports